import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as resources from './messages';

const useLanguage = (lang = 'en') => {
  return i18n.use(initReactI18next).init({
    resources,
    lng: lang,
    interpolation: {
      escapeValue: false,
    },
    cleanCode: true,
  });
};

export default useLanguage;
